module.exports = "<span [innerHtml]=\"(refPrefix + ref + refSuffix)|sanitizeHtml\"></span>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/output/footnote/footnote.component.html
// module id = ./src/app/components/output/footnote/footnote.component.html
// module chunks = main